import React, { Component } from "react";
import * as ROUTES from "../../constants/routes";
import { Grid, Row, Col } from "react-flexbox-grid";
import { withFirebase } from "../Firebase";
import TextField from "@material-ui/core/TextField";
import { Button } from "@material-ui/core";
var mandrill = require("mandrill-api/mandrill");
var mandrill_client = new mandrill.Mandrill("g-ubQ_EgdC9ImeDdfb97eA");
class CheckInPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event_id: this.props.match.params.selectedEventId,
      phone: "",
      registrations: [],
      email: "",
      attended: [],
      isLoading: true,
      event_data: {}
    };
  }

  onChange = event => {
    const {
      target: { value }
    } = event;
    this.setState({ phone: value });
  };

  onSubmitiPad = async e => {
    e.preventDefault();
    let { phone, registrations, event_id, event_data } = this.state;
    let foundFlag = false;
    let name = "";
    registrations.map(registration => {
      if (registration.phone === phone) {
        if (registration.hasOwnProperty("multi_day_attendance")) {
          for (let i = 0; i < registration.multi_day_attendance.length; i++) {
            if (!registration.multi_day_attendance[i]) {
              registration.multi_day_attendance[i] = true;
              break;
            }
          }
        } else {
          registration.multi_day_attendance = [];
          for (let i = 0; i < event_data.event_date.length; i++) {
            if (i === 0) {
              registration.multi_day_attendance.push(true);
            } else {
              registration.multi_day_attendance.push(false);
            }
          }
        }
        let full_attendance_flag = true;
        registration.multi_day_attendance.forEach(flag => {
          if (!flag) {
            full_attendance_flag = false;
          }
        });
        registration.attended = full_attendance_flag;
        name = registration.name;
        foundFlag = true;
      }
    });
    if (foundFlag) {
      this.props.firebase
        .event(event_id)
        .set({ registrations: registrations }, { merge: true });
      alert("Thank you for coming " + name);
    } else {
      this.props.firebase
        .realUsers()
        .where("phone", "==", phone)
        .get()
        .then(async snapshot => {
          console.log(snapshot);
          if (snapshot.size !== 0) {
            snapshot.forEach(doc => {
              console.log(doc.data());
              let name = doc.ref.get().then(user => {
                return user.data().firstname + " " + user.data().familyname;
              });
              console.log(doc.ref);
              Promise.resolve(name).then(name => {
                let registration = {
                  confirmed: true,
                  registered: false,
                  user: doc.ref,
                  walk_in: true,
                  name: name,
                  phone: phone
                };
                registration.multi_day_attendance = [];
                for (let i = 0; i < event_data.event_date.length; i++) {
                  if (i === 0) {
                    registration.multi_day_attendance.push(true);
                  } else {
                    registration.multi_day_attendance.push(false);
                  }
                }
                let full_attendance_flag = true;
                registration.multi_day_attendance.forEach(flag => {
                  if (!flag) {
                    full_attendance_flag = false;
                  }
                });
                registration.attended = full_attendance_flag;
                console.log(registration);
                registrations.push(registration);
                console.log(registrations);
                this.props.firebase
                  .event(event_id)
                  .set({ registrations: registrations }, { merge: true });
                alert(
                  "Thank you for coming " +
                    name +
                    ". You have been registered as a walk-in."
                );
              });
            });
          } else {
            console.log("phone number not registered");
            let email = prompt("User not found! Please enter your email.");
            let name = prompt(
              "Please enter your first and last name seperated by a space"
            );
            let nameArray = name.split(" ", 2);
            var result = "";
            var characters =
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
            var charactersLength = characters.length;
            for (var i = 0; i < 10; i++) {
              result += characters.charAt(
                Math.floor(Math.random() * charactersLength)
              );
            }
            let password = result;
            let userData = {
              firstname: nameArray[0],
              familyname: nameArray[1] === undefined ? "" : nameArray[1],
              phone: phone,
              email: email,
              password: password,
              teams: []
            };
            let message = {
              html:
                `<!doctype html>
                                  <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
                                      <head>
                                          <!-- NAME: SELL PRODUCTS -->
                                          <!--[if gte mso 15]>
                                          <xml>
                                              <o:OfficeDocumentSettings>
                                              <o:AllowPNG/>
                                              <o:PixelsPerInch>96</o:PixelsPerInch>
                                              </o:OfficeDocumentSettings>
                                          </xml>
                                          <![endif]-->
                                          <meta charset="UTF-8">
                                          <meta http-equiv="X-UA-Compatible" content="IE=edge">
                                          <meta name="viewport" content="width=device-width, initial-scale=1">
                                          <title>*|MC:SUBJECT|*</title>
                                          
                                      <style type="text/css">
                                      p{
                                        margin:10px 0;
                                        padding:0;
                                      }
                                      table{
                                        border-collapse:collapse;
                                      }
                                      h1,h2,h3,h4,h5,h6{
                                        display:block;
                                        margin:0;
                                        padding:0;
                                      }
                                      img,a img{
                                        border:0;
                                        height:auto;
                                        outline:none;
                                        text-decoration:none;
                                      }
                                      body,#bodyTable,#bodyCell{
                                        height:100%;
                                        margin:0;
                                        padding:0;
                                        width:100%;
                                      }
                                      .mcnPreviewText{
                                        display:none !important;
                                      }
                                      #outlook a{
                                        padding:0;
                                      }
                                      img{
                                        -ms-interpolation-mode:bicubic;
                                      }
                                      table{
                                        mso-table-lspace:0pt;
                                        mso-table-rspace:0pt;
                                      }
                                      .ReadMsgBody{
                                        width:100%;
                                      }
                                      .ExternalClass{
                                        width:100%;
                                      }
                                      p,a,li,td,blockquote{
                                        mso-line-height-rule:exactly;
                                      }
                                      a[href^=tel],a[href^=sms]{
                                        color:inherit;
                                        cursor:default;
                                        text-decoration:none;
                                      }
                                      p,a,li,td,body,table,blockquote{
                                        -ms-text-size-adjust:100%;
                                        -webkit-text-size-adjust:100%;
                                      }
                                      .ExternalClass,.ExternalClass p,.ExternalClass td,.ExternalClass div,.ExternalClass span,.ExternalClass font{
                                        line-height:100%;
                                      }
                                      a[x-apple-data-detectors]{
                                        color:inherit !important;
                                        text-decoration:none !important;
                                        font-size:inherit !important;
                                        font-family:inherit !important;
                                        font-weight:inherit !important;
                                        line-height:inherit !important;
                                      }
                                      .templateContainer{
                                        max-width:600px !important;
                                      }
                                      a.mcnButton{
                                        display:block;
                                      }
                                      .mcnImage,.mcnRetinaImage{
                                        vertical-align:bottom;
                                      }
                                      .mcnTextContent{
                                        word-break:break-word;
                                      }
                                      .mcnTextContent img{
                                        height:auto !important;
                                      }
                                      .mcnDividerBlock{
                                        table-layout:fixed !important;
                                      }
                                    /*
                                    @tab Page
                                    @section Heading 1
                                    @style heading 1
                                    */
                                      h1{
                                        /*@editable*/color:#222222;
                                        /*@editable*/font-family:Helvetica;
                                        /*@editable*/font-size:40px;
                                        /*@editable*/font-style:normal;
                                        /*@editable*/font-weight:bold;
                                        /*@editable*/line-height:150%;
                                        /*@editable*/letter-spacing:normal;
                                        /*@editable*/text-align:center;
                                      }
                                    /*
                                    @tab Page
                                    @section Heading 2
                                    @style heading 2
                                    */
                                      h2{
                                        /*@editable*/color:#222222;
                                        /*@editable*/font-family:Helvetica;
                                        /*@editable*/font-size:34px;
                                        /*@editable*/font-style:normal;
                                        /*@editable*/font-weight:bold;
                                        /*@editable*/line-height:150%;
                                        /*@editable*/letter-spacing:normal;
                                        /*@editable*/text-align:left;
                                      }
                                    /*
                                    @tab Page
                                    @section Heading 3
                                    @style heading 3
                                    */
                                      h3{
                                        /*@editable*/color:#444444;
                                        /*@editable*/font-family:Helvetica;
                                        /*@editable*/font-size:22px;
                                        /*@editable*/font-style:normal;
                                        /*@editable*/font-weight:bold;
                                        /*@editable*/line-height:150%;
                                        /*@editable*/letter-spacing:normal;
                                        /*@editable*/text-align:left;
                                      }
                                    /*
                                    @tab Page
                                    @section Heading 4
                                    @style heading 4
                                    */
                                      h4{
                                        /*@editable*/color:#949494;
                                        /*@editable*/font-family:Georgia;
                                        /*@editable*/font-size:20px;
                                        /*@editable*/font-style:italic;
                                        /*@editable*/font-weight:normal;
                                        /*@editable*/line-height:125%;
                                        /*@editable*/letter-spacing:normal;
                                        /*@editable*/text-align:left;
                                      }
                                    /*
                                    @tab Header
                                    @section Header Container Style
                                    */
                                      #templateHeader{
                                        /*@editable*/background-color:#F7F7F7;
                                        /*@editable*/background-image:none;
                                        /*@editable*/background-repeat:no-repeat;
                                        /*@editable*/background-position:center;
                                        /*@editable*/background-size:cover;
                                        /*@editable*/border-top:0;
                                        /*@editable*/border-bottom:0;
                                        /*@editable*/padding-top:45px;
                                        /*@editable*/padding-bottom:45px;
                                      }
                                    /*
                                    @tab Header
                                    @section Header Interior Style
                                    */
                                      .headerContainer{
                                        /*@editable*/background-color:transparent;
                                        /*@editable*/background-image:none;
                                        /*@editable*/background-repeat:no-repeat;
                                        /*@editable*/background-position:center;
                                        /*@editable*/background-size:cover;
                                        /*@editable*/border-top:0;
                                        /*@editable*/border-bottom:0;
                                        /*@editable*/padding-top:0;
                                        /*@editable*/padding-bottom:0;
                                      }
                                    /*
                                    @tab Header
                                    @section Header Text
                                    */
                                      .headerContainer .mcnTextContent,.headerContainer .mcnTextContent p{
                                        /*@editable*/color:#757575;
                                        /*@editable*/font-family:Helvetica;
                                        /*@editable*/font-size:16px;
                                        /*@editable*/line-height:150%;
                                        /*@editable*/text-align:left;
                                      }
                                    /*
                                    @tab Header
                                    @section Header Link
                                    */
                                      .headerContainer .mcnTextContent a,.headerContainer .mcnTextContent p a{
                                        /*@editable*/color:#007C89;
                                        /*@editable*/font-weight:normal;
                                        /*@editable*/text-decoration:underline;
                                      }
                                    /*
                                    @tab Body
                                    @section Body Container Style
                                    */
                                      #templateBody{
                                        /*@editable*/background-color:#ffffff;
                                        /*@editable*/background-image:none;
                                        /*@editable*/background-repeat:no-repeat;
                                        /*@editable*/background-position:center;
                                        /*@editable*/background-size:cover;
                                        /*@editable*/border-top:0;
                                        /*@editable*/border-bottom:0;
                                        /*@editable*/padding-top:36px;
                                        /*@editable*/padding-bottom:45px;
                                      }
                                    /*
                                    @tab Body
                                    @section Body Interior Style
                                    */
                                      .bodyContainer{
                                        /*@editable*/background-color:#transparent;
                                        /*@editable*/background-image:none;
                                        /*@editable*/background-repeat:no-repeat;
                                        /*@editable*/background-position:center;
                                        /*@editable*/background-size:cover;
                                        /*@editable*/border-top:0;
                                        /*@editable*/border-bottom:0;
                                        /*@editable*/padding-top:0;
                                        /*@editable*/padding-bottom:0;
                                      }
                                    /*
                                    @tab Body
                                    @section Body Text
                                    */
                                      .bodyContainer .mcnTextContent,.bodyContainer .mcnTextContent p{
                                        /*@editable*/color:#757575;
                                        /*@editable*/font-family:Helvetica;
                                        /*@editable*/font-size:16px;
                                        /*@editable*/line-height:150%;
                                        /*@editable*/text-align:left;
                                      }
                                    /*
                                    @tab Body
                                    @section Body Link
                                    */
                                      .bodyContainer .mcnTextContent a,.bodyContainer .mcnTextContent p a{
                                        /*@editable*/color:#007C89;
                                        /*@editable*/font-weight:normal;
                                        /*@editable*/text-decoration:underline;
                                      }
                                    /*
                                    @tab Footer
                                    @section Footer Style
                                    */
                                      #templateFooter{
                                        /*@editable*/background-color:#007492;
                                        /*@editable*/background-image:none;
                                        /*@editable*/background-repeat:no-repeat;
                                        /*@editable*/background-position:center;
                                        /*@editable*/background-size:cover;
                                        /*@editable*/border-top:0;
                                        /*@editable*/border-bottom:0;
                                        /*@editable*/padding-top:45px;
                                        /*@editable*/padding-bottom:63px;
                                      }
                                    /*
                                    @tab Footer
                                    @section Footer Interior Style
                                    */
                                      .footerContainer{
                                        /*@editable*/background-color:transparent;
                                        /*@editable*/background-image:none;
                                        /*@editable*/background-repeat:no-repeat;
                                        /*@editable*/background-position:center;
                                        /*@editable*/background-size:cover;
                                        /*@editable*/border-top:0;
                                        /*@editable*/border-bottom:0;
                                        /*@editable*/padding-top:0;
                                        /*@editable*/padding-bottom:0;
                                      }
                                    /*
                                    @tab Footer
                                    @section Footer Text
                                    */
                                      .footerContainer .mcnTextContent,.footerContainer .mcnTextContent p{
                                        /*@editable*/color:#FFFFFF;
                                        /*@editable*/font-family:Helvetica;
                                        /*@editable*/font-size:12px;
                                        /*@editable*/line-height:150%;
                                        /*@editable*/text-align:center;
                                      }
                                    /*
                                    @tab Footer
                                    @section Footer Link
                                    */
                                      .footerContainer .mcnTextContent a,.footerContainer .mcnTextContent p a{
                                        /*@editable*/color:#FFFFFF;
                                        /*@editable*/font-weight:normal;
                                        /*@editable*/text-decoration:underline;
                                      }
                                    @media only screen and (min-width:768px){
                                      .templateContainer{
                                        width:600px !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      body,table,td,p,a,li,blockquote{
                                        -webkit-text-size-adjust:none !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      body{
                                        width:100% !important;
                                        min-width:100% !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      .mcnRetinaImage{
                                        max-width:100% !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      .mcnImage{
                                        width:100% !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      .mcnCartContainer,.mcnCaptionTopContent,.mcnRecContentContainer,.mcnCaptionBottomContent,.mcnTextContentContainer,.mcnBoxedTextContentContainer,.mcnImageGroupContentContainer,.mcnCaptionLeftTextContentContainer,.mcnCaptionRightTextContentContainer,.mcnCaptionLeftImageContentContainer,.mcnCaptionRightImageContentContainer,.mcnImageCardLeftTextContentContainer,.mcnImageCardRightTextContentContainer,.mcnImageCardLeftImageContentContainer,.mcnImageCardRightImageContentContainer{
                                        max-width:100% !important;
                                        width:100% !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      .mcnBoxedTextContentContainer{
                                        min-width:100% !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      .mcnImageGroupContent{
                                        padding:9px !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      .mcnCaptionLeftContentOuter .mcnTextContent,.mcnCaptionRightContentOuter .mcnTextContent{
                                        padding-top:9px !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      .mcnImageCardTopImageContent,.mcnCaptionBottomContent:last-child .mcnCaptionBottomImageContent,.mcnCaptionBlockInner .mcnCaptionTopContent:last-child .mcnTextContent{
                                        padding-top:18px !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      .mcnImageCardBottomImageContent{
                                        padding-bottom:9px !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      .mcnImageGroupBlockInner{
                                        padding-top:0 !important;
                                        padding-bottom:0 !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      .mcnImageGroupBlockOuter{
                                        padding-top:9px !important;
                                        padding-bottom:9px !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      .mcnTextContent,.mcnBoxedTextContentColumn{
                                        padding-right:18px !important;
                                        padding-left:18px !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      .mcnImageCardLeftImageContent,.mcnImageCardRightImageContent{
                                        padding-right:18px !important;
                                        padding-bottom:0 !important;
                                        padding-left:18px !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                      .mcpreview-image-uploader{
                                        display:none !important;
                                        width:100% !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                    /*
                                    @tab Mobile Styles
                                    @section Heading 1
                                    @tip Make the first-level headings larger in size for better readability on small screens.
                                    */
                                      h1{
                                        /*@editable*/font-size:30px !important;
                                        /*@editable*/line-height:125% !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                    /*
                                    @tab Mobile Styles
                                    @section Heading 2
                                    @tip Make the second-level headings larger in size for better readability on small screens.
                                    */
                                      h2{
                                        /*@editable*/font-size:26px !important;
                                        /*@editable*/line-height:125% !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                    /*
                                    @tab Mobile Styles
                                    @section Heading 3
                                    @tip Make the third-level headings larger in size for better readability on small screens.
                                    */
                                      h3{
                                        /*@editable*/font-size:20px !important;
                                        /*@editable*/line-height:150% !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                    /*
                                    @tab Mobile Styles
                                    @section Heading 4
                                    @tip Make the fourth-level headings larger in size for better readability on small screens.
                                    */
                                      h4{
                                        /*@editable*/font-size:18px !important;
                                        /*@editable*/line-height:150% !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                    /*
                                    @tab Mobile Styles
                                    @section Boxed Text
                                    @tip Make the boxed text larger in size for better readability on small screens. We recommend a font size of at least 16px.
                                    */
                                      .mcnBoxedTextContentContainer .mcnTextContent,.mcnBoxedTextContentContainer .mcnTextContent p{
                                        /*@editable*/font-size:14px !important;
                                        /*@editable*/line-height:150% !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                    /*
                                    @tab Mobile Styles
                                    @section Header Text
                                    @tip Make the header text larger in size for better readability on small screens.
                                    */
                                      .headerContainer .mcnTextContent,.headerContainer .mcnTextContent p{
                                        /*@editable*/font-size:16px !important;
                                        /*@editable*/line-height:150% !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                    /*
                                    @tab Mobile Styles
                                    @section Body Text
                                    @tip Make the body text larger in size for better readability on small screens. We recommend a font size of at least 16px.
                                    */
                                      .bodyContainer .mcnTextContent,.bodyContainer .mcnTextContent p{
                                        /*@editable*/font-size:16px !important;
                                        /*@editable*/line-height:150% !important;
                                      }
                                  
                                  }	@media only screen and (max-width: 480px){
                                    /*
                                    @tab Mobile Styles
                                    @section Footer Text
                                    @tip Make the footer content text larger in size for better readability on small screens.
                                    */
                                      .footerContainer .mcnTextContent,.footerContainer .mcnTextContent p{
                                        /*@editable*/font-size:14px !important;
                                        /*@editable*/line-height:150% !important;
                                      }
                                  
                                  }</style></head>
                                      <body>
                                          <!--*|IF:MC_PREVIEW_TEXT|*-->
                                          <!--[if !gte mso 9]><!----><span class="mcnPreviewText" style="display:none; font-size:0px; line-height:0px; max-height:0px; max-width:0px; opacity:0; overflow:hidden; visibility:hidden; mso-hide:all;">*|MC_PREVIEW_TEXT|*</span><!--<![endif]-->
                                          <!--*|END:IF|*-->
                                          <center>
                                              <table align="center" border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTable">
                                                  <tr>
                                                      <td align="center" valign="top" id="bodyCell">
                                                          <!-- BEGIN TEMPLATE // -->
                                                          <table border="0" cellpadding="0" cellspacing="0" width="100%">
                                                              <tr>
                                                                  <td align="center" valign="top" id="templateHeader" data-template-container>
                                                                      <!--[if (gte mso 9)|(IE)]>
                                                                      <table align="center" border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">
                                                                      <tr>
                                                                      <td align="center" valign="top" width="600" style="width:600px;">
                                                                      <![endif]-->
                                                                      <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" class="templateContainer">
                                                                          <tr>
                                                                              <td valign="top" class="headerContainer"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnImageBlock" style="min-width:100%;">
                                      <tbody class="mcnImageBlockOuter">
                                              <tr>
                                                  <td valign="top" style="padding:9px" class="mcnImageBlockInner">
                                                      <table align="left" width="100%" border="0" cellpadding="0" cellspacing="0" class="mcnImageContentContainer" style="min-width:100%;">
                                                          <tbody><tr>
                                                              <td class="mcnImageContent" valign="top" style="padding-right: 9px; padding-left: 9px; padding-top: 0; padding-bottom: 0; text-align:center;">
                                                                  
                                                                      
                                                                          <img align="center" alt="" src="https://gallery.mailchimp.com/fb4329cdce8364eae47b6bbf0/images/9e974b75-11a2-4992-a1d5-6f324744f93d.png" width="564" style="max-width:4726px; padding-bottom: 0; display: inline !important; vertical-align: bottom;" class="mcnImage">
                                                                      
                                                                  
                                                              </td>
                                                          </tr>
                                                      </tbody></table>
                                                  </td>
                                              </tr>
                                      </tbody>
                                  </table></td>
                                                                          </tr>
                                                                      </table>
                                                                      <!--[if (gte mso 9)|(IE)]>
                                                                      </td>
                                                                      </tr>
                                                                      </table>
                                                                      <![endif]-->
                                                                  </td>
                                                              </tr>
                                                              <tr>
                                                                  <td align="center" valign="top" id="templateBody" data-template-container>
                                                                      <!--[if (gte mso 9)|(IE)]>
                                                                      <table align="center" border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">
                                                                      <tr>
                                                                      <td align="center" valign="top" width="600" style="width:600px;">
                                                                      <![endif]-->
                                                                      <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" class="templateContainer">
                                                                          <tr>
                                                                              <td valign="top" class="bodyContainer"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">
                                      <tbody class="mcnTextBlockOuter">
                                          <tr>
                                              <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">
                                                  <!--[if mso]>
                                          <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
                                          <tr>
                                          <![endif]-->
                                            
                                          <!--[if mso]>
                                          <td valign="top" width="600" style="width:600px;">
                                          <![endif]-->
                                                  <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">
                                                      <tbody><tr>
                                                          
                                                          <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">
                                                          
                                                              <pre data-placeholder="Translation" dir="rtl" id="tw-target-text" style="text-align: center;">
                                  <span style="font-size:32px"><span style="color:#696969"><span style="font-family:arial,helvetica neue,helvetica,sans-serif">مرحبًا
                                  </span></span></span>
                                  <span style="font-size:27px"><span style="font-family:arial,helvetica neue,helvetica,sans-serif">كلمة المرور المؤقتة: ` +
                password +
                `
                                  </span><a href = "https://thakaa.sa/reset-password?email=` +
                email +
                `">إعادة تعيين كلمة المرور</a></span>
                                  <span></span>
                                  </pre>
                                  
                                                          </td>
                                                      </tr>
                                                  </tbody></table>
                                          <!--[if mso]>
                                          </td>
                                          <![endif]-->
                                                  
                                          <!--[if mso]>
                                          </tr>
                                          </table>
                                          <![endif]-->
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">
                                      <tbody class="mcnDividerBlockOuter">
                                          <tr>
                                              <td class="mcnDividerBlockInner" style="min-width: 100%; padding: 18px;">
                                                  <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width: 100%;border-top-width: 2px;border-top-style: solid;border-top-color: #FFFFFF;">
                                                      <tbody><tr>
                                                          <td>
                                                              <span></span>
                                                          </td>
                                                      </tr>
                                                  </tbody></table>
                                  <!--            
                                                  <td class="mcnDividerBlockInner" style="padding: 18px;">
                                                  <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
                                  -->
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table></td>
                                                                          </tr>
                                                                      </table>
                                                                      <!--[if (gte mso 9)|(IE)]>
                                                                      </td>
                                                                      </tr>
                                                                      </table>
                                                                      <![endif]-->
                                                                  </td>
                                                              </tr>
                                                              <tr>
                                                                  <td align="center" valign="top" id="templateFooter" data-template-container>
                                                                      <!--[if (gte mso 9)|(IE)]>
                                                                      <table align="center" border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">
                                                                      <tr>
                                                                      <td align="center" valign="top" width="600" style="width:600px;">
                                                                      <![endif]-->
                                                                      <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" class="templateContainer">
                                                                          <tr>
                                                                              <td valign="top" class="footerContainer"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnFollowBlock" style="min-width:100%;">
                                      <tbody class="mcnFollowBlockOuter">
                                          <tr>
                                              <td align="center" valign="top" style="padding:9px" class="mcnFollowBlockInner">
                                                  <table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnFollowContentContainer" style="min-width:100%;">
                                      <tbody><tr>
                                          <td align="center" style="padding-left:9px;padding-right:9px;">
                                              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;" class="mcnFollowContent">
                                                  <tbody><tr>
                                                      <td align="center" valign="top" style="padding-top:9px; padding-right:9px; padding-left:9px;">
                                                          <table align="center" border="0" cellpadding="0" cellspacing="0">
                                                              <tbody><tr>
                                                                  <td align="center" valign="top">
                                                                      <!--[if mso]>
                                                                      <table align="center" border="0" cellspacing="0" cellpadding="0">
                                                                      <tr>
                                                                      <![endif]-->
                                                                      
                                                                          <!--[if mso]>
                                                                          <td align="center" valign="top">
                                                                          <![endif]-->
                                                                          
                                                                          
                                                                              <table align="left" border="0" cellpadding="0" cellspacing="0" style="display:inline;">
                                                                                  <tbody><tr>
                                                                                      <td valign="top" style="padding-right:10px; padding-bottom:9px;" class="mcnFollowContentItemContainer">
                                                                                          <table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnFollowContentItem">
                                                                                              <tbody><tr>
                                                                                                  <td align="left" valign="middle" style="padding-top:5px; padding-right:10px; padding-bottom:5px; padding-left:9px;">
                                                                                                      <table align="left" border="0" cellpadding="0" cellspacing="0" width="">
                                                                                                          <tbody><tr>
                                                                                                              
                                                                                                                  <td align="center" valign="middle" width="24" class="mcnFollowIconContent">
                                                                                                                      <a href="https://twitter.com/Thakaa_Center" target="_blank"><img src="https://cdn-images.mailchimp.com/icons/social-block-v2/outline-light-twitter-48.png" alt="Twitter" style="display:block;" height="24" width="24" class=""></a>
                                                                                                                  </td>
                                                                                                              
                                                                                                              
                                                                                                          </tr>
                                                                                                      </tbody></table>
                                                                                                  </td>
                                                                                              </tr>
                                                                                          </tbody></table>
                                                                                      </td>
                                                                                  </tr>
                                                                              </tbody></table>
                                                                          
                                                                          <!--[if mso]>
                                                                          </td>
                                                                          <![endif]-->
                                                                      
                                                                          <!--[if mso]>
                                                                          <td align="center" valign="top">
                                                                          <![endif]-->
                                                                          
                                                                          
                                                                              <table align="left" border="0" cellpadding="0" cellspacing="0" style="display:inline;">
                                                                                  <tbody><tr>
                                                                                      <td valign="top" style="padding-right:10px; padding-bottom:9px;" class="mcnFollowContentItemContainer">
                                                                                          <table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnFollowContentItem">
                                                                                              <tbody><tr>
                                                                                                  <td align="left" valign="middle" style="padding-top:5px; padding-right:10px; padding-bottom:5px; padding-left:9px;">
                                                                                                      <table align="left" border="0" cellpadding="0" cellspacing="0" width="">
                                                                                                          <tbody><tr>
                                                                                                              
                                                                                                                  <td align="center" valign="middle" width="24" class="mcnFollowIconContent">
                                                                                                                      <a href="https://www.linkedin.com/company/thakaa-center/" target="_blank"><img src="https://cdn-images.mailchimp.com/icons/social-block-v2/outline-light-linkedin-48.png" alt="LinkedIn" style="display:block;" height="24" width="24" class=""></a>
                                                                                                                  </td>
                                                                                                              
                                                                                                              
                                                                                                          </tr>
                                                                                                      </tbody></table>
                                                                                                  </td>
                                                                                              </tr>
                                                                                          </tbody></table>
                                                                                      </td>
                                                                                  </tr>
                                                                              </tbody></table>
                                                                          
                                                                          <!--[if mso]>
                                                                          </td>
                                                                          <![endif]-->
                                                                      
                                                                          <!--[if mso]>
                                                                          <td align="center" valign="top">
                                                                          <![endif]-->
                                                                          
                                                                          
                                                                              <table align="left" border="0" cellpadding="0" cellspacing="0" style="display:inline;">
                                                                                  <tbody><tr>
                                                                                      <td valign="top" style="padding-right:0; padding-bottom:9px;" class="mcnFollowContentItemContainer">
                                                                                          <table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnFollowContentItem">
                                                                                              <tbody><tr>
                                                                                                  <td align="left" valign="middle" style="padding-top:5px; padding-right:10px; padding-bottom:5px; padding-left:9px;">
                                                                                                      <table align="left" border="0" cellpadding="0" cellspacing="0" width="">
                                                                                                          <tbody><tr>
                                                                                                              
                                                                                                                  <td align="center" valign="middle" width="24" class="mcnFollowIconContent">
                                                                                                                      <a href="mailto:Support@thakaa.sa" target="_blank"><img src="https://cdn-images.mailchimp.com/icons/social-block-v2/outline-light-forwardtofriend-48.png" alt="Email" style="display:block;" height="24" width="24" class=""></a>
                                                                                                                  </td>
                                                                                                              
                                                                                                              
                                                                                                          </tr>
                                                                                                      </tbody></table>
                                                                                                  </td>
                                                                                              </tr>
                                                                                          </tbody></table>
                                                                                      </td>
                                                                                  </tr>
                                                                              </tbody></table>
                                                                          
                                                                          <!--[if mso]>
                                                                          </td>
                                                                          <![endif]-->
                                                                      
                                                                      <!--[if mso]>
                                                                      </tr>
                                                                      </table>
                                                                      <![endif]-->
                                                                  </td>
                                                              </tr>
                                                          </tbody></table>
                                                      </td>
                                                  </tr>
                                              </tbody></table>
                                          </td>
                                      </tr>
                                  </tbody></table>
                                  
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">
                                      <tbody class="mcnDividerBlockOuter">
                                          <tr>
                                              <td class="mcnDividerBlockInner" style="min-width: 100%; padding: 18px;">
                                                  <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width: 100%;border-top-width: 2px;border-top-style: solid;border-top-color: #FFFFFF;">
                                                      <tbody><tr>
                                                          <td>
                                                              <span></span>
                                                          </td>
                                                      </tr>
                                                  </tbody></table>
                                  <!--            
                                                  <td class="mcnDividerBlockInner" style="padding: 18px;">
                                                  <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
                                  -->
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">
                                      <tbody class="mcnTextBlockOuter">
                                          <tr>
                                              <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">
                                                  <!--[if mso]>
                                          <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
                                          <tr>
                                          <![endif]-->
                                            
                                          <!--[if mso]>
                                          <td valign="top" width="600" style="width:600px;">
                                          <![endif]-->
                                                  <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">
                                                      <tbody><tr>
                                                          
                                                          <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">
                                                          
                                                              <em>Copyright © 2019 Thakaa Center, All rights reserved.</em><br>
                                  <br>
                                  Want to change how you receive these emails?<br>
                                  You can <a href="*|UPDATE_PROFILE|*">update your preferences</a> or <a href="*|UNSUB|*">unsubscribe from this list</a>.<br>
                                  <br>
                                  <img data-file-id="278705" height="100" src="https://gallery.mailchimp.com/fb4329cdce8364eae47b6bbf0/images/370b1a7f-f2dd-43b3-8a5b-eaf6b4f3e691.png" style="border: 0px  ; width: 127px; height: 100px; margin: 0px;" width="127">
                                                          </td>
                                                      </tr>
                                                  </tbody></table>
                                          <!--[if mso]>
                                          </td>
                                          <![endif]-->
                                                  
                                          <!--[if mso]>
                                          </tr>
                                          </table>
                                          <![endif]-->
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table></td>
                                                                          </tr>
                                                                      </table>
                                                                      <!--[if (gte mso 9)|(IE)]>
                                                                      </td>
                                                                      </tr>
                                                                      </table>
                                                                      <![endif]-->
                                                                  </td>
                                                              </tr>
                                                          </table>
                                                          <!-- // END TEMPLATE -->
                                                      </td>
                                                  </tr>
                                              </table>
                                          </center>
                                      </body>
                                  </html>
                                  `,
              subject: "حسابك في مركز ذكاء",
              from_email: "support@thakaa.sa",
              from_name: "مركز ذكاء",
              to: [
                {
                  email: email
                }
              ],
              tags: ["otp"]
            };
            console.log(message);
            console.log("sending password....");
            await mandrill_client.messages.send(
              {
                message: message
              },
              function(result) {
                console.log(result);
              },
              function(err) {
                console.log(err);
              }
            );
            this.props.firebase
              .doCreateUserWithEmailandPassword(email, password)
              .catch(err => {
                alert(
                  "Error creating account. You may already have an account linked to this email. Please update your phone number on your account or contact support for help at support@thakaa.sa"
                );
              })
              .then(user => {
                if (user === undefined) {
                  return;
                } else {
                  console.log(user);
                  delete userData.password;
                  console.log("temp user creted: " + user.user.uid);
                  this.props.firebase
                    .realUsers()
                    .doc(user.user.uid)
                    .set(userData);

                  let registration = {
                    confirmed: true,
                    registered: false,
                    user: this.props.firebase.realUsers().doc(user.user.uid),
                    walk_in: true,
                    name: name,
                    phone: phone
                  };
                  console.log(registration);
                  registrations.push(registration);
                  console.log(registrations);
                  this.props.firebase
                    .event(event_id)
                    .set({ registrations: registrations }, { merge: true })
                    .then(() => {
                      alert(
                        "Thank you for coming " +
                          name +
                          ". You have been registered as a walk-in. Please check your email to set your Thakaa account password and update your details."
                      );
                    });
                }
              });
          }
        });
    }
    this.setState({ isLoading: false });
  };

  componentDidMount() {
    let { event_id } = this.state;
    var registrations = this.props.firebase
      .event(event_id)
      .get()
      .then(doc => {
        return doc.data().registrations;
      });
    Promise.resolve(registrations).then(registrations => {
      this.setState({ registrations });
      console.log(registrations);
    });
    var eventData = this.props.firebase
      .event(event_id)
      .get()
      .then(doc => {
        return doc.data();
      });
    Promise.resolve(eventData).then(event_data => {
      this.setState({ event_data, isLoading: false });
    });
  }
  render() {
    let { phone, isLoading } = this.state;
    return (
      <div>
        <Grid>
          <form
            onSubmit={() => {
              return false;
            }}
          >
            <Row center="xs">
              <Col>
                <img
                  src="https://uploads-ssl.webflow.com/5c7f727e11f5c63fc62e2131/5c7f8bdb9f434c97669712c8_thakaa%20logo.png"
                  style={{
                    height: "fit-content",
                    paddingTop: "50px",
                    paddingBottom: "50px"
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Row center="xs">
                  <Col xs={6}>
                    <TextField
                      fullWidth={true}
                      id="i-pad"
                      label="Phone"
                      variant="outlined"
                      size="large"
                      value={phone}
                      onChange={this.onChange}
                      placeholder="05XXXXXXXX"
                      type="number"
                      disabled={isLoading}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Row center="xs">
                  <Col xs={6}>
                    <Button
                      variant="outlined"
                      type="submit"
                      onClick={this.onSubmitiPad}
                      disabled={isLoading}
                    >
                      Check-In
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </form>
        </Grid>
      </div>
    );
  }
}
export default withFirebase(CheckInPage);
